<template>
  <DataIterat
    :headless="fetching"
    searchable
    :filterable="meta && meta.last_page !== 1"
    :bulk-actionable="meta && meta.total > 1"
    actionable
    :paginatable="meta && meta.last_page !== 1"
    v-bind="{ items: adsets, loading: fetching, meta }"
    v-on="{ getData: getAdsets }"
  >
    <DataIteratHeaderContent slot="list-header-content" />
    <DataIteratItemContent
      slot="list-item-content"
      slot-scope="{ dataItem: adset }"
      :adset="adset"
    />
  </DataIterat>
</template>

<script>
import DataIterat from '@/components/Ui/DataIterat.vue';
import { entityComputed } from '@/store/helper';
import DataIteratHeaderContent from './DataIteratHeaderContent.vue';
import DataIteratItemContent from './DataIteratItemContent.vue';

export default {
  name: 'FacebookAdsetList',
  components: {
    DataIterat,
    DataIteratHeaderContent,
    DataIteratItemContent,
  },
  props: {
    fetching: Boolean,
    adsets: {
      type: Array,
      default: () => [],
    },
    meta: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...entityComputed,
  },
  methods: {
    getAdsets(queryParams = {}) {
      this.$emit('get-adsets', queryParams);
    },
  },
};
</script>
